
import React from 'react';

import acep from '../images/logos-acreditaciones/logo-acep.png';
import colling from '../images/logos-acreditaciones/logo-alianzas-colling.png';
import azul from '../images/logos-acreditaciones/logo-bandera-azul.png';
import candbridge from '../images/logos-acreditaciones/logo-candbridge.png';
import cultural from '../images/logos-acreditaciones/logo-centro-cultural.png';
import cloud from '../images/logos-acreditaciones/logo-cloud-campus.png';
import edutec from '../images/logos-acreditaciones/logo-edutec.png';
import learn from '../images/logos-acreditaciones/logo-imagine-learning.png';
import mep from '../images/logos-acreditaciones/logo-mep.png';
import itarar from '../images/logos-acreditaciones/logo-parque.png';
import schoolcloud from '../images/logos-acreditaciones/logo-school-cloud.png';
import cemp from '../images/logos-acreditaciones/logo-space-cemp.png';
import transp from '../images/logos-acreditaciones/logo-transparent-languaje.png';


export class Acreditaciones extends React.Component {

  // lalista(receptor) {
  //     return receptor.map ((txt, index) => {
  //       return <Item 
  //                name={ txt.url } 
  //                // area={ txt.field_area_practica } 
  //                // cargo={ txt.field_cargo } 
  //                // pais={ txt.field_pais } 
  //                // foto={ txt.src }
  //                >
  //             </Item>
  //     })
  // }

	render() {

		return (
			<>
			<section className="acreditaciones" >
				<div className="wrapContentIner">
					<h2>ACREDITACIONES</h2>
					</div>
				<div className="wrapLogos">
					<figure><img src={acep} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={colling} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={azul} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={candbridge} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={cultural} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={cloud} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={edutec} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={learn} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={mep} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={itarar} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={schoolcloud} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={cemp} alt="preescolar primaria secundaria"/></figure>
					<figure><img src={transp} alt="preescolar primaria secundaria"/></figure>
				</div>

				{/*<Loop/>*/}

				</section>
			</>
		)
	}
}


	// function Loop(){
	// 	return(
	//     <div className="loopJason">
	//       <h2>Json Array Object </h2>
	//       {people.map((data, idx) => (
	//         <p>
	//         <span>{data.name}</span><br/>
	//         <span>{data.apellido}</span>
	//         </p>
	//       ))}
	//     </div>
	//     )
	// }
	

  // const people = [
  //   { name: "name 1", apellido:"apellido 1" },
  //   { name: "name 2", apellido:"apellido 2" },
  //   { name: "name 3", apellido:"apellido 3" },
  //   { name: "name 4", apellido:"apellido 4" },
  //   { name: "name 5", apellido:"apellido 5" },
  //   { name: "name 6", apellido:"apellido 6" },
  //   { name: "name 7", apellido:"apellido 7" },
  //   { name: "name 8", apellido:"apellido 8" }
  // ];


export default Acreditaciones


